// import React, { useEffect, useState } from "react";
// import { connect } from "react-redux";
// import { Button } from "reactstrap";
// import { compose } from "redux";
// import { addtime, edittime, viewtime, addVenueTime, editVenueTime, viewAllVenueTime } from "services/timesettingServices";
// import enhancer from "./enhancer/settingEnhancer";
// import NavigationActions from "redux/navigation/actions";
// import Loader from "components/Loader";

// const { success, error } = NavigationActions;
// const Setting = props => {
//   const {
//     values,
//     handleChange,
//     handleBlur,
//     errors,
//     touched,
//     submitCount,
//     token,
//     isValid,
//     setValues,
//     handleSubmit
//   } = props;
//   const [loading, setLoading] = useState(false);
//   const [id, setId] = useState(false);
//   const [refresh, toggleRefresh] = useState(true);

//   const getTimeData = async () => {
//     await viewtime(token).then(res => {
//       if (res.success) {
//         setId(res.data[0]?._id);
//         setValues({ ...res.data[0] });
//         toggleRefresh(false);
//       } else {
//         error(res.message);
//       }
//     });
//   };

//   useEffect(() => {
//     refresh && getTimeData();
//   }, [refresh]);

//   const Error = props => {
//     const field1 = props.field;
//     if ((errors[field1] && touched[field1]) || submitCount > 0) {
//       return (
//         <span className={props.class ? props.class : "error-msg"}>
//           {errors[field1]}
//         </span>
//       );
//     } else {
//       return <span />;
//     }
//   };

//   const handleTimeSubmit = async e => {
//     e.preventDefault();
//     handleSubmit();
//     if (isValid) {
//       setLoading(true);
//       id
//         ? await edittime(token, id, values).then(res => {
//           if (res.success) {
//             success(res.message);
//             toggleRefresh(true);
//             setLoading(false);
//           } else {
//             error(res.message);
//             setLoading(false);
//           }
//         })
//         : await addtime(token, values).then(res => {
//           if (res.success) {
//             success(res.message);
//             toggleRefresh(true);
//             setLoading(false);
//           } else {
//             error(res.message);
//             setLoading(false);
//           }
//         });
//     }
//   };

//   return (
//     <>
//       <div className="form-group">
//         <label>
//           Time(Minute)<span className="red">*</span>
//         </label>
//         <input
//           type="text"
//           className="form-control react-form-input"
//           onChange={handleChange}
//           onBlur={handleBlur}
//           name="thresholdtime"
//           id="thresholdtime"
//           value={values.thresholdtime}
//           style={{ width: "unset" }}
//           placeholder="Please Enter Time Value"
//         />
//       </div>
//       <Error field="thresholdtime" />
//       <div className="form-group">
//         <Button
//           onClick={e => handleTimeSubmit(e)}
//           disabled={isValid ? false : true}
//           className="btn form-button modaladdbutton"
//           style={{ width: "unset" }}
//         >
//           Save
//         </Button>
//       </div>
//       {loading ? <Loader /> : ""}
//     </>
//   );
// };

// const mapStateToProps = state => {
//   return {
//     ...state.themeChanger,
//     token: state.auth.accessToken
//   };
// };

// export default compose(
//   // withRouter,
//   enhancer,
//   connect(mapStateToProps, { success, error })
// )(Setting);

import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Button, Table } from "reactstrap";
import { compose } from "redux";
import {
  addtime,
  edittime,
  viewtime,
  addVenueTime,
  editVenueTime, // The service you provided
  viewAllVenueTime
} from "services/timesettingServices";
import enhancer from "./enhancer/settingEnhancer";
import NavigationActions from "redux/navigation/actions";
import Loader from "components/Loader";

const { success, error } = NavigationActions;

const Setting = props => {
  const {
    values,
    handleChange,
    handleBlur,
    errors,
    touched,
    submitCount,
    token,
    isValid,
    setValues,
    handleSubmit
  } = props;

  // --- State for Single Time Setting ---
  const [loading, setLoading] = useState(false);
  const [id, setId] = useState(false);
  const [refresh, toggleRefresh] = useState(true);

  // --- State for Venue Time Settings ---
  const [venueTimeSettings, setVenueTimeSettings] = useState([]);
  const [editId, setEditId] = useState(null); // Tracks the ID of the row being edited
  const [editValue, setEditValue] = useState(""); // Holds the temporary edit value

  // --- Service Calls ---

  // Function to fetch the single time data
  const getTimeData = async () => {
    // ... (Your existing logic for viewtime)
    await viewtime(token).then(res => {
      if (res.success) {
        setId(res.data[0]?._id);
        setValues({ ...res.data[0] });
        // We handle refresh toggling after both fetches
      } else {
        error(res.message);
      }
    });
  };

  // Function to fetch all venue time settings
  const getAllVenueTimeData = async () => {
    setLoading(true);
    await viewAllVenueTime(token).then(res => {
      setLoading(false);
      if (res.success) {
        setVenueTimeSettings(res.data);
      } else {
        error(res.message);
      }
      toggleRefresh(false); // Toggle refresh only after all API calls are complete
    });
  };

  // Handle Venue Time Input Change
  const handleVenueTimeChange = e => {
    setEditValue(e.target.value);
  };

  // Handle Edit Button Click
  const handleEditClick = item => {
    setEditId(item._id); // Set the ID of the item being edited
    setEditValue(item.thresholdtime); // Set the current value into the input
  };

  // Handle Save Button Click for Venue Time
  const handleVenueSave = async venueTimeId => {
    if (!editValue || isNaN(editValue) || Number(editValue) <= 0) {
      error("Please enter a valid positive number for time.");
      return;
    }

    setLoading(true);
    const data = {
      _id: venueTimeId, // Pass the ID for the backend service (as per your backend logic)
      thresholdtime: editValue
    };

    await editVenueTime(token, venueTimeId, data).then(res => {
      setLoading(false);
      if (res.success) {
        success(res.message);
        // Update the local state with the new value immediately
        setVenueTimeSettings(prevSettings =>
          prevSettings.map(setting =>
            setting._id === venueTimeId
              ? { ...setting, thresholdtime: editValue }
              : setting
          )
        );
        // Reset edit mode
        setEditId(null);
        setEditValue("");
      } else {
        error(res.message);
      }
    });
  };

  // Handle Cancel Button Click
  const handleCancelClick = () => {
    setEditId(null);
    setEditValue("");
  };

  // --- Effects and Helpers ---

  useEffect(() => {
    if (refresh) {
      getTimeData();
      getAllVenueTimeData();
    }
  }, [refresh]);

  const Error = props => {
    const field1 = props.field;
    if ((errors[field1] && touched[field1]) || submitCount > 0) {
      return (
        <span className={props.class ? props.class : "error-msg"}>
          {errors[field1]}
        </span>
      );
    } else {
      return <span />;
    }
  };

  const handleTimeSubmit = async e => {
    e.preventDefault();
    handleSubmit();
    // ... (Your existing logic for single time setting submission)
    if (isValid) {
      setLoading(true);
      id
        ? await edittime(token, id, values).then(res => {
            if (res.success) {
              success(res.message);
              toggleRefresh(true);
              setLoading(false);
            } else {
              error(res.message);
              setLoading(false);
            }
          })
        : await addtime(token, values).then(res => {
            if (res.success) {
              success(res.message);
              toggleRefresh(true);
              setLoading(false);
            } else {
              error(res.message);
              setLoading(false);
            }
          });
    }
  };

  return (
    <>
      {/* <div className="form-group">
        <label>
          Time(Minute)<span className="red">*</span>
        </label>
        <input
          type="text"
          className="form-control react-form-input"
          onChange={handleChange}
          onBlur={handleBlur}
          name="thresholdtime"
          id="thresholdtime"
          value={values.thresholdtime}
          style={{ width: "unset" }}
          placeholder="Please Enter Time Value"
        />
      </div>
      <Error field="thresholdtime" />
      <div className="form-group">
        <Button
          onClick={(e) => handleTimeSubmit(e)}
          disabled={isValid ? false : true}
          className="btn form-button modaladdbutton"
          style={{ width: "unset" }}
        >
          Save
        </Button>
      </div> */}

      <h2 className="mt-4">Venue-wise Time Settings</h2>
      {loading && editId === null ? (
        <Loader />
      ) : venueTimeSettings.length > 0 ? (
        <Table striped bordered>
          <thead>
            <tr>
              <th>Sr.No.</th>
              <th>Venue Name</th>
              <th>Threshold Time (Minutes)</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {venueTimeSettings.map((item, index) => (
              <tr key={item._id}>
                <th scope="row">{index + 1}</th>
                <td>{item.venue_id ? item.venue_id.name : "N/A"}</td>
                <td>
                  {editId === item._id ? (
                    <input
                      type="string"
                      value={editValue}
                      onChange={handleVenueTimeChange}
                      className="form-control form-control-sm"
                      style={{ width: "100px" }}
                      min="1"
                    />
                  ) : (
                    item.thresholdtime
                  )}
                </td>
                <td>
                  {editId === item._id ? (
                    <>
                      <Button
                        color="success"
                        size="sm"
                        onClick={() => handleVenueSave(item._id)}
                        disabled={loading}
                        className="mr-2"
                      >
                        {loading ? "Saving..." : "Save"}
                      </Button>
                      <Button
                        color="secondary"
                        size="sm"
                        onClick={handleCancelClick}
                        disabled={loading}
                      >
                        Cancel
                      </Button>
                    </>
                  ) : (
                    <Button
                      color="primary"
                      size="sm"
                      onClick={() => handleEditClick(item)}
                    >
                      Edit
                    </Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <p>No Venue Time Settings Found.</p>
      )}

      {loading && editId !== null && <Loader />}
    </>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    token: state.auth.accessToken
  };
};

export default compose(
  enhancer,
  connect(mapStateToProps, { success, error })
)(Setting);
